import { render, staticRenderFns } from "./basket-header.vue?vue&type=template&id=474a9b43&scoped=true"
import script from "./basket-header.vue?vue&type=script&lang=js"
export * from "./basket-header.vue?vue&type=script&lang=js"
import style0 from "./basket-header.vue?vue&type=style&index=0&id=474a9b43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474a9b43",
  null
  
)

export default component.exports